export default [["de", {
  "choreography": {
    "routines": {
      "type": {
        "individual": "Einzelkür",
        "large-group": "Großgruppe",
        "pair": "Paarkür",
        "small-group": "Kleingruppe"
      }
    }
  },
  "judging-system-2019": {
    "performance": {
      "choreography": {
        "dynamics": {
          "interval": {
            "0": "Kein Tempowechsel. Das Tempo ist durchweg konstant",
            "1": "Wenige Tempowechsel",
            "3": "Tempowechsel sind variabel",
            "6": "Tempowechsel liegen über dem Durchschnitt",
            "7": "Fahrer und Tempo(wechsel) harmonieren gut miteinander",
            "8": "Tempowechsel geschehen mit Leichtigkeit und absichtlich",
            "9": "Tempowechsel sind nahtlos und absichtlich"
          },
          "name": "Dynamik"
        },
        "harmony": {
          "interval": {
            "0": "Die Choreographie erweckt unter keinen Umständen das Gefühl eines vereinheitlichten Tanzes",
            "1": "Die Platzierungen der Bewegungen sind zusammenhaltslos",
            "3": "Die Choreographie erweckt Gefühl eines zur Hälfte vereinheitlichten Tanzes",
            "5": "Ein Großteil der Choreographie erweckt das Gefühl eines einheitlichen Tanzes",
            "7": "Die Choreographie erweckt größtenteils das Gefühl eines vereinheitlichten Tanzes",
            "9": "Die Choreographie erweckt das Gefühl eines komplett vereinheitlichten Tanzes, bei dem alle Teile ausbalanciert sind"
          },
          "name": "Harmonie"
        },
        "imaginativeness": {
          "interval": {
            "0": "Keine Kreativität erkennbar, ähnliche Küren wurden schon mehrere Male davor gezeigt",
            "1": "Wenig Kreativität und Einfallsreichtum ist bei der Erstellung der Kür erkennbar",
            "3": "Etwas Kreativität und Einfallsreichtum ist bei der Erstellung der Kür erkennbar",
            "5": "Durchschnittlicher Kreativitätslevel und Einfallsreichtum beim Erstellen",
            "6": "Kreativitätslevel und Einfallsreichtum beim Erstellen der Kür liegen über dem Durchschnitt",
            "7": "Große Kreativität wurde bei der Erstellung der Kür, mitsamt Bewegungen, bewiesen",
            "9": "Vollkommenes einfallsreiches Konzept und Bewegungen die zu einer Kür führen, die es noch nie gab"
          },
          "name": "Einfallsreichtum"
        },
        "name": "Choreographie",
        "purpose": {
          "interval": {
            "0": "Die meisten bis garkeine Bewegungen passen in das Konzept",
            "1": "Viele Bewegungen passen nicht zum Konzept",
            "2": "Einige Bewegungen passen nicht zum Konzept",
            "3": "Einige isoliert gruppierte Bewegungen die in das Konzept passen",
            "4": "Kür entspricht dem Konzept",
            "5": "Unterschiedliche Bewegungen in Bezug zum Konzept",
            "6": "Einige interessante und kreative Bewegungen, die den Rhythmus gut ausnutzen",
            "7": "Interessante Bewegungen, die sich aus dem Konzept ableiten lassen",
            "8": "Varietät an innovativen Bewegungen die das Konzept ausmachen",
            "9": "Einprägsame Moment gleichmäßig über die Kür verteilt, die eine vereinheitliche Kür ergeben"
          },
          "name": "Zweck"
        },
        "utilization": {
          "interval": {
            "0": "Wenig unterschiedliche Fahrwege",
            "2": "Die Elemente sind zwar gut auf der Fahrfläche untergebracht, aber manchmal bleibt der Fahrer zu lange an einem Ort",
            "5": "Durchschnittliche Ausnutzung der Fahrfläche, wenig unterschiedliche Fahrrichtungen oder Muster",
            "6": "Ausnutzung der Fahrfläche etwas über dem Durchschnitt",
            "7": "Gute Ausnutzung der Fahrfläche",
            "8": "Exzellente Ausnutzung der Fahrfläche",
            "9": "Der Fahrer nutzt die gesamte Fläche exzellent aus, um Bewegungen in unterschiedlichen Richtungen und Mustern fließen zu lassen"
          },
          "name": "Fahrwege"
        }
      },
      "execution": {
        "authenticity": {
          "interval": {
            "0": "Extrem dürftige Rolle, der Fahrer ist nie in seiner Rolle",
            "1": "Sehr dürftige Authentizität; der Fahrer ist fast nie in seiner Rolle",
            "2": "Der Fahrer ist gelegentlich in seiner Rolle",
            "4": "Durchschnittliche Authentizität; Es gibt Momente da ist der Fahrer nicht in seiner Rolle",
            "6": "Authentizität etwas über dem Durchschnitt; Der Fahrer spielt zum Großteil seine Rolle",
            "7": "Gute Authentizität",
            "8": "Sehr gute Authentizität",
            "9": "Fantastische Authentizität. Der Fahrer ist eins mit seiner Rolle"
          },
          "name": "Authentizität"
        },
        "carriage": {
          "interval": {
            "0": "Extrem dürftige Körperhaltung",
            "1": "Sehr dürftige Körperhaltung und  Körperspannung nicht sichtbar",
            "2": "Dürftige Körperhaltung und Körperspannung nicht sichtbar",
            "3": "Körperhaltung schwankende, Körperspannung nicht sichtbar",
            "4": "Angemessene Körperhaltung, Körperspannung erahnbar",
            "5": "Körperspannung gerade noch sichtbar, aber mit Unterbrechungen",
            "6": "Körperspannung in Körper und Extremitäten gerade sichtbar",
            "7": "Gute Körperhaltung mit sichtbarer Körperspannung",
            "8": "Sehr gute  Körperhaltung, mit sichtbarer, aber angemessener Körperspannung und Muskeltonus",
            "9": "Exzellente, Haltung von Körper und Extremitäten, mit sichtbarer, aber angemessener Körperspannung und Muskeltonus"
          },
          "name": "Körperhaltung"
        },
        "clarity": {
          "interval": {
            "0": "Keine Bewegung geschieht mit Absicht",
            "1": "Sehr wenige klare Bewegungen; viele Bewegungen sind unabsichtlich",
            "3": "Durchschnittliche Klarheit; einige Bewegungen sind präzise andere sind unabsichtlich",
            "6": "Nahezu alle Bewegungen werden präzise und absichtlich ausgeführt",
            "9": "Präzise und klare Bewegungsausführung"
          },
          "name": "Klarheit"
        },
        "name": "Ausführung",
        "presence": {
          "interval": {
            "0": "Keine Präsenz vorhanden",
            "1": "Sehr dürftige Präsenz, Die Performance wächst dem Fahrer über den Kopf",
            "2": "Gelegentliches andeuten von Präsenz; Augen schauen auf den Boden",
            "4": "Durchschnittliches Wirken/Auftreten (?)",
            "6": "Engagement etwas über dem Durchschnitt",
            "7": "Gutes Engagement",
            "8": "Ziemlich gute emotionale, intellektuelle und physische Präsenz",
            "9": "Faszinierende Präsenz"
          },
          "name": "Präsenz"
        },
        "projection": {
          "interval": {
            "0": "Mühsam und erzwungene Kommunikation",
            "1": "Sehr beeinträchtige kommunikative Fähigkeiten",
            "2": "Beeinträchtige kommunikative Fähigkeiten, zurückhaltend",
            "3": "Gelegentliche Kommunikation",
            "4": "Kommunikation bei etwa 50%",
            "5": "Die Kommunikation variiert während der Kür",
            "6": "Etwa 75% der Zeit wird die Kür kommuniziert",
            "7": "Die Kür wird größtenteils kommuniziert",
            "8": "Sehr überzeugende Kommunikation",
            "9": "Exzellente Kommunikation, das Publikum fühlt sich zur Kür hingezogen"
          },
          "name": "Körpersprache"
        },
        "variety": {
          "interval": {
            "0": "Konstanter Ausdruck  während der gesamten Kür",
            "1": "Wenig Varietät aber der Ausdruck passt zur Kür",
            "2": "Ein bisschen Varietät, Ausdruck und Attitüden aber eigentlich hat der Fahrer während der Kür immer den gleichen Ausdruck",
            "4": "Durchschnittliches Level an Kreativität, Attitüden und Ausdruck",
            "6": "Der Fahrer verwendet eine große Varietät an Attitüden und Ausdrücken um das Publikum ansprechen",
            "9": "Exzellente Kreativität der Attitüde und Ausdruck während der Kür"
          },
          "name": "Stimmung"
        }
      },
      "music": {
        "expression": {
          "interval": {
            "0": "Die Kür sieht zerstückelt aus und Fahrer, Musik und Nuancen sind nicht miteinander verbunden",
            "2": "Die Kür bietet hier und da einige Zusammenhalte aber Fahrer, Musik und Nuancen sind nicht integriert",
            "5": "Fahrer, Musik und Nuancen passen zu großen Teilen der Kür zusammen, um ein stimmiges Gesamtbild zu erzeugen",
            "9": "Fahrer, Musik und Nuancen kommen von „Herzen“"
          },
          "name": "Expression"
        },
        "finesse": {
          "interval": {
            "0": "Der Fahrer missachtet die Nuancen der Musik; die Kür ist monoton",
            "2": "Der Fahrer nutzt die Musik selten als Inspiration und Nuancen werden nicht genutzt um eine bessere Kür zu zeigen",
            "5": "Der Fahrer verwandelt die Nuancen der Musik zu großen Teilen der Kür um, verpasst aber einige wichtige essentielle Momente",
            "9": "Der Fahrer verwandelt die Nuancen der Musik meisterhaft und ausgezeichnet und pflegt sie in das Gesamtkonzept der Kür ein"
          },
          "name": "Finesse"
        },
        "name": "Musik / Timing",
        "realization": {
          "interval": {
            "0": "Der Fahrer nutzt nie eine geeignete musikalische Umsetzung, die Kür sähe auch ohne ohne Musik gleich aus",
            "2": "Die genutzte musikalische Umsetzung passt zu einigen Stellen, die Musik läu  aber zu größtenteils im Hintergrund",
            "5": "Die genutzte musikalische Umsetzung ist etwas über Durchschnitt aber zu großen Teilen der Musik gegenwärtig",
            "9": "Geeignete musikalische Umsetzung wird kontinuierlich während der gesamten Kür genutzt"
          },
          "name": "Kontinuität & Musikalische Umsetzung"
        },
        "timing": {
          "interval": {
            "0": "Die Bewegungen sind ungeplant und ihre Anordnung ist in Bezug auf das Timing mangelhaft",
            "2": "Das Timing zwischen Fahrer und Musik stimmt manchmal, oft fehlt aber ein gelungene Verbindung",
            "5": "Der Fahrer schafft eine Verbindung zwischen Musik und Kür, die zu großen Teilen der Kür gegenwärtig ist",
            "9": "Der Fahrer kreiert meisterhaft ausdrucksstarke Momente durch Bewegungen, die zusammengesetzt eine bindende, wohl-abgestimmte Kür ergeben"
          },
          "name": "Timing"
        }
      },
      "name": "Performance"
    }
  }
}]];